import { render, staticRenderFns } from "./StFile.vue?vue&type=template&id=9f5c426c"
import script from "./StFile.vue?vue&type=script&lang=js"
export * from "./StFile.vue?vue&type=script&lang=js"
import style0 from "./StFile.vue?vue&type=style&index=0&id=9f5c426c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports